window.addEventListener("load", function () {

    // setTimeout(function () {
    //     var trigscroll = document.querySelector("a.trigscroll");
    //     if (trigscroll) trigscroll.click();
    // }, 1000);

});